<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{showSendInvoice == 'generate' ? modalName : showSendInvoice ==
                            'send' ?"Send Invoices" : "Invoice Generation"}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onSaveChanges()">
                </div>
                <hr>
                <div *ngIf="showSendInvoice == 'generate'">
                    <form [formGroup]="commissionForm" #data>
                        <div class="">
                            <label class="lblInput" for="title">Select Start Date</label><span
                                style="color: #DC4A4A; padding: 2px;;">*</span>
                            <input type="date" max="{{today}}" class="form-control input" formControlName="from_date"
                                data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': generated && controls.from_date.errors?.required}">
                            <div class="text-danger">
                                <div *ngIf="generated && controls.from_date.errors">
                                    Start Date is required!
                                </div>
                            </div>

                        </div>
                        <div class="mt-2">
                            <label class="lblInput" for="title">Select End Date
                            </label><span style="color: #DC4A4A; padding: 2px;;">*</span>
                            <input type="date" max="{{today}}" class="form-control input" formControlName="to_date"
                                data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': generated && controls.from_date.errors?.required}">
                            <div class="text-danger">
                                <div *ngIf="generated && controls.from_date.errors">
                                    End Date is required!
                                </div>
                            </div>

                        </div>
                        <div class="mt-2" *ngIf="type == 'Orders'">
                            <label class="lblInput" for="title">Select Brand</label>
                            <select class='form-control bulkInput ' id="spicker_shop_brand" formControlName="brand_id"
                                data-style="dropdownCustomStyle">
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing Selected
                                </option>
                                <option *ngFor="let brand of brands" [ngValue]="brand.brand_id">
                                    {{brand.brand_name}} </option>
                            </select>
                        </div>
                        <div class="mt-2">
                            <label class="lblInput" for="title">Select Outlet</label><span
                                style="color: #DC4A4A; padding: 2px;;">*</span>
                            <select class='form-control bulkInput ' id="spicker_shop" formControlName="outlet_code"
                                data-style="dropdownCustomStyle">
                                <option selected value='' disabled
                                    data-content="<span class='text-secondary'>Nothing Selected</span>">Nothing Selected
                                </option>
                                <option *ngFor="let shop of shops" [ngValue]="shop.code">
                                    {{shop.name}} </option>
                            </select>
                        </div>
                        <div class="text-danger">
                            <div *ngIf="generated && controls.outlet_code.errors">
                                Outlet is required!
                            </div>
                        </div>
                    </form>
                    <div class="mt-2 mb-3" *ngIf="generated">
                        <p class="alert alert-success m-0" *ngIf="generatedSuccess && message != ''">
                            {{message}}
                        </p>
                        <p class="alert alert-danger m-0" *ngIf="!generatedSuccess && message != ''">
                            {{message}}
                        </p>
                    </div>
                    <div class="col-md-12 mt-3 modal-button-div p-0">
                        <button class="btn modal-btn-button" type="button" (click)="onGenerateClick()">
                            <span *ngIf="!loading">Generate Invoice</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
                <div *ngIf="showSendInvoice == 'send'">
                    <form [formGroup]="sendForm" #data>
                        <div class="">
                            <label class="lblInput mb-2" for="title">Do you want to send your generated invoice to a
                                recipient? Then type the recipient’s email address below.</label>
                            <input type="email" class="form-control input" formControlName="email"
                                data-style="dropdownCustomStyle"
                                [ngClass]="{ 'is-invalid': sendInvoice && sendControls.email.errors}">
                            <div *ngIf="sendInvoice && sendControls.email.errors" class="text-danger">
                                <div *ngIf="sendControls.email.errors.required">
                                    Email address is required!
                                </div>
                                <div *ngIf="sendControls.email.errors.email">Email must be
                                    a valid email address!</div>
                            </div>
                        </div>
                    </form>
                    <div class="mt-2 mb-3" *ngIf="sendInvoice">
                        <p class="alert alert-success m-0" *ngIf="sentSuccess && sentMessage != ''">
                            {{sentMessage}}
                        </p>
                        <p class="alert alert-danger m-0" *ngIf="!sentSuccess && sentMessage != ''">
                            {{sentMessage}}
                        </p>
                    </div>
                    <div class="col-md-12 modal-button-div mt-2">
                        <button class="btn modal-btn-button" type="button" (click)="onSendInvoices()">
                            <span *ngIf="!sentLoading">Send Invoice</span>
                            <div *ngIf="sentLoading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
                <div *ngIf="showSendInvoice == 'success'">
                    <div class="messageContainer">
                        <h5 class="successMessage">Your invoice generated successfully!</h5>
                        <p class="mt-2">You can you view invoices <span class="hyperLink"
                                (click)="onClick()">here</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>